import React, { FC } from 'react'
import AddNewOuthouseCompany from 'containers/OuthouseCompanies/AddNewOuthouseCompany'

const NewOuthouseCompanyPage: FC = () => <AddNewOuthouseCompany />

export default NewOuthouseCompanyPage
